import { runInAction } from 'mobx';
import { IProductObject } from '@features/categories';
import ProductState from '@features/categories/mobx/state/ProductState';
import { IInspirationProduct } from '@features/cms/typescript';
const prepareProductsArray = (products: IInspirationProduct[]) => {
  const productsArray: Array<IProductObject> = [];
  products.forEach(product => {
    const {
      rap
    } = product;
    const rapObject = Array.isArray(rap) && !rap.length ? null : rap;
    runInAction(() => {
      const productState = new ProductState({
        ...product,
        rap: rapObject
      });
      productsArray.push(productState);
    });
  });
  return productsArray;
};
export default prepareProductsArray;